import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ProductCreateWfoodcostImagePage } from "../../product-create/product-create-without-foodcost/product-create-wfoodcost-image/product-create-wfoodcost-image";
import { ProductCreateFoodcostImagePage } from "../../product-create/product-create-foodcost/product-create-foodcost-image/product-create-foodcost-image";
import { ProductsServices } from "../../services";
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

@Component({
    selector: 'page-product-view-photo',
    templateUrl: 'product-view-photo.html',
})
export class ProductViewPhotoPage {
    @Input() product: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public productsServices: ProductsServices,
        public globals: Globals,) {
    }

    edit() {
        if (this.globals.checkLimitsByLicense("stock", "image")) {
            if (this.product.sub_recipe == false) {
                this.navCtrl.push(ProductCreateWfoodcostImagePage, {
                    update_state: true,
                    product_uid: this.product.UID,
                    image_url: this.product.image_url,
                    image: this.product.image,
                    product_name: this.product.name,
                    product: this.product
                })
            } else {
                this.navCtrl.push(ProductCreateFoodcostImagePage, {
                    update_state: true,
                    product_uid: this.product.UID,
                    image_url: this.product.image_url,
                    image: this.product.image,
                    product_name: this.product.name,
                    product: this.product
                })
            }
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-photo/product-view-photo.ts